// Copyright 2022, Imprivata, Inc.  All rights reserved.

import type { CodingContext } from '@imprivata-cloud/data-privacy-js';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { usePlatform } from '../../context/platform/hooks';
import { apiClient } from '../client';

const getGrantStatusQueryKey = 'get-grant-status';

interface GetGrantStatusResponse {
  consentRequired: boolean;
  pendingAuthorization: boolean;
  pendingHandoff: boolean;
}

const getGrantStatusQuery = (codingContext: CodingContext | undefined): Promise<GetGrantStatusResponse> => {
  return apiClient.get<GetGrantStatusResponse>('grant', codingContext);
};

export const useGetGrantStatusQuery = (isEnabled = false) => {
  const [enabled, setEnabled] = useState(isEnabled);
  const { codingContext } = usePlatform();
  const query = useQuery({
    queryKey: [getGrantStatusQueryKey],
    queryFn: () => getGrantStatusQuery(codingContext),
    enabled: enabled,
  });

  return {
    grantStatus: query.data,
    isLoading: query.isLoading,
    error: query.error,
    enable: () => setEnabled(true),
  };
};
